/**
 * Navigatsiya: 5 ta tab + ustma-ust ochiladigan ekranlar steki. Telegram BackButton stek bo'sh bo'lmaganda ko'rinadi.
 * Dars/o'yin ekranlari ham shu stekda ('lesson', 'arcade') — ularning ichki holati o'z store'ida.
 */
import { create } from 'zustand';
import type { Word } from '../data/types';

export type Tab = 'home' | 'sets' | 'games' | 'max' | 'profile'; // 'max' tab menyuda yo'q (MVP), tur mosligi uchun qoldi
export type GameKey = 'cards' | 'learn' | 'match' | 'test' | 'listen' | 'gap' | 't60' | 'meteor' | 'snake';
export type MaxKey = 'radio' | 'books' | 'shadow';

export type Screen =
  | { k: 'rank' }
  | { k: 'settings' }
  | { k: 'setEditor'; id: number | null }
  | { k: 'picker'; game: GameKey }
  | { k: 'maxDetail'; key: MaxKey; from?: Tab }
  | { k: 'tariffs' }
  | { k: 'lesson' }                                  // useLesson store ichidagi mashg'ulot (dars, mashq, test, kartochkalar, juftlik)
  | { k: 'finish' }                                  // dars yakuni
  | { k: 'arcade'; game: 't60' | 'meteor'; pool: Word[] }
  | { k: 'arcadeEnd'; title: string; score: number; best: number; isRec: boolean; xp: number; again: () => void }
  | { k: 'duel'; code?: string }                     // So'z jangi (menyu; code — havola orqali kelgan do'st jangi)
  | { k: 'snake'; pool: Word[] }                     // So'z ilon
  | { k: 'numbers' }                                 // Sonlar
  | { k: 'forms'; from: Tab }                        // So'z shakllari (hub + mashqlar)
  | { k: 'avatar' };                                 // Avatar muharriri

interface Nav {
  tab: Tab;
  stack: Screen[];
  setTab: (t: Tab) => void;
  push: (s: Screen) => void;
  replace: (s: Screen) => void;
  pop: () => void;
  /** Stekni tozalab tabga qaytish. */
  home: (t?: Tab) => void;
}

export const useNav = create<Nav>((set) => ({
  tab: 'home',
  stack: [],
  setTab: (tab) => set({ tab, stack: [] }),
  push: (s) => set((n) => ({ stack: [...n.stack, s] })),
  replace: (s) => set((n) => ({ stack: [...n.stack.slice(0, -1), s] })),
  pop: () => set((n) => ({ stack: n.stack.slice(0, -1) })),
  home: (t) => set((n) => ({ tab: t ?? n.tab, stack: [] })),
}));

export const nav = {
  push: (s: Screen) => useNav.getState().push(s),
  replace: (s: Screen) => useNav.getState().replace(s),
  pop: () => useNav.getState().pop(),
  home: (t?: Tab) => useNav.getState().home(t),
  tab: (t: Tab) => useNav.getState().setTab(t),
};
